/**
 * Csv Schema of ResponsavelConfigSms
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelConfigSms} from '@/model/resource/ResponsavelConfigSms'

/* TODO: review generated schema */
export class CsvResponsavelConfigSmsSchema extends Schema {
  readonly name = 'CsvResponsavelConfigSms'

  readonly fieldSet: FieldSet<ResponsavelConfigSms> = {
    idConfigSmsPk: schema => schema.model.idConfigSmsPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    mensagem: schema => schema.model.mensagem,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
